"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PremiumCourseCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}